import React from 'react';
import { GenericCardProps, SearchFacet } from './../../../types/search';

const getCategoryLabel = (categoryId?: string | number, facets?: SearchFacet[]): string | undefined => {
  if (!categoryId || !facets) return undefined;
  const categoryFacet = facets.find(f => f.key.toLowerCase().includes('category'));
  if (!categoryFacet) return undefined;
  const item = categoryFacet.items.find(i => i.value === String(categoryId));
  return item?.label;
};

const FeaturedArticleCard = ({ data, facets }: { data: GenericCardProps; facets?: SearchFacet[] }) => {
  const srcSet = Array.isArray(data.imageInfo?.srcSets) ? data.imageInfo.srcSets.join(', ') : data.imageInfo?.srcSets;
  let categoryId = '';
  if (typeof data.primaryCategory === 'object' && data.primaryCategory?.id) {
    categoryId = String(data.primaryCategory.id);
  } else if (typeof data.primaryCategory === 'string' || typeof data.primaryCategory === 'number') {
    categoryId = String(data.primaryCategory);
  }
  const categoryLabel = getCategoryLabel(categoryId, facets);
  return (
    <a className="page-reference-card" href={data.relativePath}>
      <div className="page-reference-card__image">
        <img
          loading="lazy"
          src={data.imageInfo?.src}
          srcSet={srcSet}
          sizes={data.imageInfo?.sizes}
          alt={data.imageInfo?.altText || data.heading}
        />
      </div>
      <div className="page-reference-card__content">
        <div className="page-reference-card__content-wrapper">
          <div className="page-reference-card__meta">
            <p className="page-reference-card__category">
              <span>{categoryLabel ?? categoryId}</span>
            </p>
            {data.publishingDate && <p className="page-reference-card__date">{data.publishingDate}</p>}
          </div>
          <h3 className="page-reference-card__title">{data.heading}</h3>
          <p className="page-reference-card__description">{data.description}</p>
        </div>
        <div className="page-reference-card__icon-wrapper">
          <svg className="page-reference-card__icon icon" aria-hidden="true">
            <use href="/dist/assets/icons/sprite.svg#arrow-right"></use>
          </svg>
        </div>
      </div>
    </a>
  );
};

export default FeaturedArticleCard;
